/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */

'use client';

import { useContext } from 'react';
import { SplitPromptSequenceContext } from '@/context';

export const useSplitPromptSequence = () =>
  useContext(SplitPromptSequenceContext);
